import { useRouter } from '#app'
import * as Sentry from '@sentry/vue'
/* Utils */
import { getSentryIntegrations } from '../utils/getSentryIntegrations'
/* Types */
import { Mode } from '../types'

/* Плагин для прокидывания sentry в контекст приложения */
export default defineNuxtPlugin({
  name: 'initSentry',
  parallel: true,
  setup({ vueApp }) {
    const { SENTRY_DSN, MODE } = useRuntimeConfig().public
    const router = useRouter()

    /* В зависимости от прода, выставляем нужное значение */
    const sampleRate = MODE === Mode.RELEASE ? 0.5 : 0.2

    /* Инициализация Sentry */
    Sentry.init({
      app: vueApp,
      dsn: SENTRY_DSN as string,
      enabled: MODE !== Mode.DEVELOPMENT,
      environment: MODE as Mode,

      tracesSampleRate: sampleRate,

      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })

    /* Lazy-load загрузка sentry плагинов */
    getSentryIntegrations({ router })

    return {
      provide: {
        sentryCaptureException: Sentry.captureException,
      },
    }
  },
})
